import React from 'react';

import PropTypes from 'prop-types';

import { InlineFieldContainer } from 'components/common';
import FormContainer from 'components/common/FormContainer';

import RequestPasswordReset from './components/RequestPasswordReset';

const propTypes = {
  title: PropTypes.string,
};

const defaultProps = {
  title: 'Security',
};

function ChangePasswordForm({ title }) {
  return (
    <FormContainer loadedKeyPath={['user', 'core']}>
      <InlineFieldContainer title={<h2>{title}</h2>} enableDelete={false}>
        <RequestPasswordReset />
      </InlineFieldContainer>
    </FormContainer>
  );
}

ChangePasswordForm.propTypes = propTypes;
ChangePasswordForm.defaultProps = defaultProps;

export default ChangePasswordForm;
